import useUser from "../../../../hooks/useUser";
import * as ENUM from "../enums/UserTableHeaderColumns";

export default function useGetTableConst() {
  const { roles } = useUser();
  const tableFields = roles.adminOrEmployee ? ENUM.clinicUserTableFields :ENUM.masterFields;
  const header = roles.adminOrEmployee ? ENUM.ClinicUserTableHeaderColumns :ENUM.MasterUserTableHeaderColumns;
  return { tableFields, header };
}
